<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        登记资料提交
        <template slot="operate">
          <el-button
            v-if="operationSuper.权限分配"
            plain
            class="operate-btn"
            @click="$router.push('/permissionAssignment')"
            >申请权限分配</el-button
          >
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="showAddBtn"
            class="g-form-section-search operate__item"
            title="新增"
            icon="el-icon-plus"
            @click="handleAdd"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.bookingDate">
            <el-date-picker
              v-model="slotForms.forms.bookingDate"
              format="yyyy"
              value-format="yyyy"
              type="year"
              placeholder="选择年"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.bookingStatus">
            <el-select
              v-model="slotForms.forms.bookingStatus"
              clearable
              placeholder="表单状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.companyName">
            <el-input
              v-model="slotForms.forms.companyName"
              placeholder="申请企业"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="150"
          align="center"
          :prop="item.name"
          :label="item.title"
        >
          <template slot-scope="{ row }">
            <div v-if="item.name == 'file'">
              <el-button type="text" @click="downloadFile(row)">
                下载</el-button
              >
            </div>
            <div v-else>
              {{ row[item.name] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="150">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.详情"
              :to="{
                path: '/truckPassRegistrationDetail',
                query: {
                  bookingId: scope.row.bookingId,
                  bookingStatus: scope.row.bookingStatus
                }
              }"
              >详情</router-link
            >&nbsp;
            <router-link
              v-if="
                operationSuper.编辑 &&
                  (scope.row.bookingStatus == 0 ||
                    scope.row.bookingStatus == 20)
              "
              :to="{
                path: '/truckPassRegistrationEdit',
                query: {
                  bookingId: scope.row.bookingId,
                  bookingStatus: scope.row.bookingStatus
                }
              }"
              >编辑</router-link
            >&nbsp;
            <router-link
              v-if="operationSuper.审核 && scope.row.bookingStatus == 10"
              :to="{
                path: '/truckPassRegistrationExamine',
                query: {
                  bookingId: scope.row.bookingId
                }
              }"
              >审核</router-link
            >&nbsp;
            <el-button
              v-if="operationSuper.删除 && scope.row.bookingStatus == 0"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import {
  deleteBooking,
  getApplyPurview,
  checkApplyPurview
} from "@/api/businessApplication";
import { mapActions } from "vuex";
import operationManage from "_private/mixins/operationManage";
import listInit from "@/mixins/listInit";
import moment from "moment";
export default {
  mixins: [operationManage, listInit],
  data() {
    return {
      // dataType: "object",
      isSearch: false,
      formExtend: {
        forms: {
          bookingDate: moment().format("YYYY"),
          bookingStatus: "",
          companyName: ""
        },
        extends: []
      },
      statusOptions: [
        {
          value: 0,
          label: "草稿"
        },
        {
          value: 10,
          label: "审核中"
        },
        {
          value: 20,
          label: "已驳回"
        },
        {
          value: 30,
          label: "已通过"
        }
      ],
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      idList: [],
      errMess: "",
      isFirstLoad: true,
      showAddBtn: false,
      canApplyDate: "",
      // 请求表格数据
      tableDataUrl: "/reserve/booking/list",
      //导出URL
      exportUrl: "/reserve/booking/export?"
    };
  },

  created() {
    this.setSearchFormIsOpenAct();
    this.queryApplyPurview();
    this.initPage();
  },
  mounted() {
    let idStr = this.$route.query.vehicleIds;
    if (idStr) {
      this.idList = idStr.split(",");
    }
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 判断企业是否有权限
    async queryApplyPurview() {
      try {
        this.loading = true;
        let { code, result } = await getApplyPurview();
        if (code) {
          this.showAddBtn = true;
          this.canApplyDate = result.canApplyDateStr;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    //获取选中区位id
    getVehicleIdListParam() {
      let selected = this.$refs.vehicleTreeSelect.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    // 删除行
    deleteRow({ row }) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await deleteBooking({
            bookingId: row.bookingId
          });

          this.tableLoading = false;

          if (code === 1) {
            this.$message.success("删除成功");
            this.handleCurrentChange(1);
            this.initVehicleTree();
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {
          console.log();
        });
    },
    // 下载
    downloadFile({ bookingId }) {
      try {
        document.location.href = `/reserve/booking/download?bookingId=${bookingId}`;
      } catch (err) {
        console.log(err);
      }
    },

    //重置
    handleResetForm() {
      this.formExtend.forms.selfDate = moment().format("YYYY"); // 自评年份
    },
    // 导出
    handleExportClick() {
      let param = "";
      param += "&bookingDate=" + this.formExtend.forms.bookingDate;
      param += "&bookingStatus=" + this.formExtend.forms.bookingStatus;
      param += "&companyName=" + this.formExtend.forms.companyName;
      document.location.href = this.exportUrl + param;
    },
    async handleAdd() {
      try {
        this.loading = true;
        let { code, message } = await checkApplyPurview({
          bookingDateStr: this.formExtend.forms.bookingDate
        });
        if (code == 0) {
          this.$message.error(message);
        } else {
          this.$router.push({
            path: "/truckPassRegistrationAdd",
            query: { canApplyDate: this.canApplyDate }
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}

/deep/ .e6-from--column-2 .vehicle_temp {
  width: 100px !important;
}
.operate-btn {
  height: 29px;
  color: #fff;
  background: #2f4ef2;
  border-color: #2f4ef2;
  &:hover {
    color: #fff;
    background: #2f4ef2;
    border-color: #2f4ef2;
  }
}
</style>
